// Libs
import ReactGA from "react-ga";

// Utils
import { trackPinterestEvent } from "../../utils/eventTracker";

/**
 * Tracking the History API pushState and replaceState.
 * @returns {void}
 */
export default function initTrackingURL() {
  // Wrapping each function using the track closure
  window.history.pushState = track(window.history.pushState, handler);
  window.history.replaceState = track(window.history.replaceState, handler);

  /**
   * The popstate event of the Window interface is fired when the active history entry changes
   * while the user navigates the session history.
   */
  window.addEventListener("popstate", handler);
}

// Private methods

/**
 * @param  {function} func
 * @param  {function} handler
 * @returns {function} interceptor
 */
function track(func, handler) {
  return function interceptor() {
    let result = func.apply(this, arguments);
    handler.apply(this, arguments);

    return result;
  };
}

let lastURL = "";

/**
 * @returns {void}
 */
function handler() {
  const newURL = getFullURL();

  if (newURL !== lastURL) {
    pageView(newURL);
  }

  lastURL = getFullURL();
}

/**
 * Getting URL + Query String
 * @returns {string}
 */
function getFullURL() {
  return `${window.location.pathname}${window.location.search}`;
}

/**
 * Triggering page view events
 * @param  {string} page
 * @returns {void}
 */
function pageView(page) {
  const userId = localStorage.getItem("shop_id");
  const params = userId ? { userId, page } : { page };

  // Google Analytics
  try {
    if (
      process.env.NODE_ENV === "production" ||
      process.env.NODE_ENV === "staging"
    ) {
      ReactGA.set(params);
      ReactGA.pageview(page);
    }
  } catch (err) {
    console.log(err);
  }

  // Pinterest Pixel
  try {
    trackPinterestEvent("pagevisit");
  } catch (err) {
    console.log(err);
  }
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/trackUrl.js